import { PositionReference } from "../../utilities/local-utilities";
export function getSideSlopeChunk(pointInfos, getReferencePosition, isClosed) {
    const sideSlopePoints = [];
    let tempPointInfos = [];
    let chunkPositionReference = PositionReference.ABOVE;
    for (let i = 0; i < pointInfos.length; ++i) {
        const positionReference = getReferencePosition(pointInfos[i].position);
        if (chunkPositionReference === positionReference &&
            tempPointInfos.length > 0) {
            //continued
            tempPointInfos.push(pointInfos[i]);
        }
        else {
            tempPointInfos.length > 0 &&
                sideSlopePoints.push({
                    positionReference: chunkPositionReference,
                    pointInfos: tempPointInfos,
                });
            tempPointInfos = [pointInfos[i]];
            chunkPositionReference = positionReference;
        }
    }
    tempPointInfos.length > 0 &&
        sideSlopePoints.push({
            positionReference: chunkPositionReference,
            pointInfos: tempPointInfos,
        });
    for (let i = 0; i < sideSlopePoints.length; ++i) {
        if (sideSlopePoints[i].positionReference === PositionReference.OUTSIDE) {
            const next = sideSlopePoints[(i + 1) % sideSlopePoints.length];
            const prev = sideSlopePoints[(sideSlopePoints.length + i - 1) % sideSlopePoints.length];
            if (prev === next) {
                sideSlopePoints[i].positionReference = prev.positionReference;
            }
            else if (prev.positionReference === next.positionReference) {
                sideSlopePoints[i].positionReference = prev.positionReference;
            }
            else if (prev !== sideSlopePoints[i]) {
                sideSlopePoints[i].positionReference = prev.positionReference;
            }
            else if (next !== sideSlopePoints[i]) {
                sideSlopePoints[i].positionReference = next.positionReference;
            }
        }
    }
    const result = [];
    for (const chunk of sideSlopePoints) {
        const isPointAbove = chunk.positionReference !== PositionReference.BELOW;
        if (result[result.length - 1] &&
            result[result.length - 1].isPointAbove === isPointAbove) {
            result[result.length - 1].pointInfos.push(...chunk.pointInfos);
        }
        else {
            result.push({
                isPointAbove,
                pointInfos: chunk.pointInfos,
            });
        }
    }
    if (isClosed && result.length > 1) {
        if (result[0].isPointAbove === result[result.length - 1].isPointAbove) {
            const beginingPart = result.pop();
            result[0].pointInfos.unshift(...beginingPart.pointInfos);
        }
    }
    return result;
}
//# sourceMappingURL=utils.js.map